import { render, staticRenderFns } from "./DocusignEditAdditionalDocumentSignTab.vue?vue&type=template&id=03fa9d20&"
import script from "./DocusignEditAdditionalDocumentSignTab.vue?vue&type=script&lang=ts&"
export * from "./DocusignEditAdditionalDocumentSignTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports